var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _vm.formStore.request_type
      ? _c(
          "div",
          { staticClass: "e-form-row m-block" },
          [
            _c(
              "div",
              {
                staticClass: "e-form-row",
                attrs: { id: "_form_field_request" }
              },
              [
                _c("div", { staticClass: "e-input-label m-full" }, [
                  _c("span", { staticClass: "e-input-mark m-required" }, [
                    _vm._v("必須")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "e-input-label" }, [
                    _vm._v("ご来店の目的")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "e-input-field" }, [
                  _c("div", { staticClass: "e-field-grid" }, [
                    _c("div", { staticClass: "e-field-grid-col m-sp-full" }, [
                      _c(
                        "label",
                        { staticClass: "c-input-field-radio m-inline" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.store.request_type,
                                expression: "store.request_type"
                              }
                            ],
                            staticClass: "e-input",
                            attrs: { type: "radio" },
                            domProps: {
                              value: 1,
                              checked: _vm._q(_vm.store.request_type, 1)
                            },
                            on: {
                              input: _vm.changeType,
                              change: function($event) {
                                return _vm.$set(_vm.store, "request_type", 1)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "e-label" }, [
                            _vm._v("モデルハウス購入を検討している")
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "e-field-grid-col m-sp-full" }, [
                      _c(
                        "label",
                        { staticClass: "c-input-field-radio m-inline" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.store.request_type,
                                expression: "store.request_type"
                              }
                            ],
                            staticClass: "e-input",
                            attrs: { type: "radio" },
                            domProps: {
                              value: 2,
                              checked: _vm._q(_vm.store.request_type, 2)
                            },
                            on: {
                              input: _vm.changeType,
                              change: function($event) {
                                return _vm.$set(_vm.store, "request_type", 2)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "e-label" }, [
                            _vm._v("注文住宅建築を検討している")
                          ])
                        ]
                      )
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _vm.hasCustomRequest
              ? _c("request-custom")
              : _vm.store.request_type === 1
              ? _c("request-model")
              : _c("request-new")
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "e-form-row m-block" },
          [_c("request-new")],
          1
        ),
    _vm._v(" "),
    _vm.formStore.request_alert
      ? _c("div", { staticClass: "e-form-row" }, [
          _c("div", { staticClass: "e-request-alert" }, [
            _c("div", {
              staticClass: "e-request-alert-text",
              domProps: { innerHTML: _vm._s(_vm.formStore.request_alert) }
            })
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "e-form-row" }, [
      _c(
        "div",
        { staticClass: "e-input-field" },
        [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.store.request_other,
                expression: "store.request_other"
              }
            ],
            staticClass: "c-input-field-text m-full",
            class: _vm.inputFieldClass,
            attrs: {
              name: "request_other",
              rows: "5",
              placeholder: _vm.request_other_placeholder
            },
            domProps: { value: _vm.store.request_other },
            on: {
              blur: _vm.validateHandler,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.store, "request_other", $event.target.value)
              }
            }
          }),
          _vm._v(" "),
          _vm.errorStore.request_other.value
            ? _vm._l(_vm.errorStore.request_other.value, function(
                error,
                index
              ) {
                return _c(
                  "small",
                  { key: index, staticClass: "e-input-note m-invalid" },
                  [_vm._v("※" + _vm._s(error))]
                )
              })
            : _vm._e()
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }